import React from 'react';
import PropTypes from 'prop-types';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import ReportingProps from '@bingads-webui-campaign-react/props-reporting';
import _ from 'underscore';
import { Select } from '@bingads-webui-react/primitive';

const getTimeZoneSelectorStyle = () => ({
  reportTimeZoneSelector: { maxWidth: 285 },
});


export const TimeZoneSelector = React.memo(({
  timeZoneValue, onChange, i18n, options, id, disabled, ariaLabelledByID,
}) => {
  const optionsJsx = _.keys(options).map(key =>
    (
      <option key={key} id={`${id}Option-${key}`} value={key}>
        {i18n.getString(options[key])}
      </option>
    ));
  const classes = useDefaultStyles(getTimeZoneSelectorStyle);


  return (
    <div className={classes.reportTimeZoneSelector}>
      <Select id={`${id}Selector`} value={timeZoneValue} onChange={({ target: { value } }) => onChange({ timeZone: value })} disabled={disabled} aria-labelledby={ariaLabelledByID}>
        {optionsJsx}
      </Select>
    </div>
  );
});

TimeZoneSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  i18n: ReportingProps.i18n.isRequired,
  options: PropTypes.objectOf(PropTypes.string.isRequired).isRequired,
  id: PropTypes.string.isRequired,
  timeZoneValue: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  ariaLabelledByID: PropTypes.string,
};

TimeZoneSelector.defaultProps = {
  disabled: false,
  ariaLabelledByID: '',
};
